import { c as _c } from "react/compiler-runtime";
import { SvgStarFill } from '@common/icon';
import { cn } from '@core/utils';
interface RateInputProps {
  value: number;
  onChange: (value: number) => void;
}
export const RateInput = t0 => {
  const $ = _c(7);
  const {
    value: t1,
    onChange
  } = t0;
  const value = t1 === undefined ? 0 : t1;
  let t2;
  if ($[0] !== onChange || $[1] !== value) {
    t2 = rating => {
      if (value === rating) {
        onChange(0);
      } else {
        onChange(rating);
      }
    };
    $[0] = onChange;
    $[1] = value;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleStarClick = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [1, 2, 3, 4, 5];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== handleStarClick || $[5] !== value) {
    t4 = <div className="flex gap-1">{t3.map(rating_0 => <button key={rating_0} type="button" onClick={() => handleStarClick(rating_0)} className="focus:outline-none" aria-label={`별점 ${rating_0}점`}><SvgStarFill className={cn({
          "text-Y-550": rating_0 <= value,
          "text-Gray-300": rating_0 > value
        })} /></button>)}</div>;
    $[4] = handleStarClick;
    $[5] = value;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
};